module.exports = __webpack_public_path__ + "next.svg?8b9b04837db3868482ca7725b6854615";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/next.svg
// module id = 6
// module chunks = 0